import React, {useEffect, useRef, useState} from "react";
import {Row} from "antd";
import {useFetch} from "../../hooks/useFetch";
import stores from "../../store/stores";
import Filters from "./filters/Filters";

import ResponsiveDataTable from "./responsiveDataTable/ResponsiveDataTable";
import ActionButtons from "./actionButtons/ActionButtons";

export const AvailableCouriers = () => {
    const [recall, setRecall] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [filters, setFilters] = useState({
        city: undefined,
        companyId: undefined,
        subcompanyId: undefined,
        courierType: undefined,
        preferredCourierId: undefined,
        forceCourierId: undefined,
        pool: undefined,
        distance: 0
    });

    const [loading, availableCouriers] = useFetch({
        fetchFn: stores.courierStore.listAvailableCouriers.bind(null, {
            subCompanyId: filters?.subcompanyId,
            courierType:
                filters?.courierType && filters?.courierType !== "all"
                    ? filters?.courierType
                    : undefined,
            pool: filters?.pool,
            distance: 100000,
            availableCouriersPage: true,
        }),
        waitForResponse: true,
        condition: Boolean(filters?.subcompanyId) && Boolean(filters?.courierType),
        initialCall: false,
        dependencies: [recall]
    });

    return (
        <div>
            <Row gutter={[8, 8]}>
                <Filters
                    setCurrentPage={setCurrentPage}
                    setFilters={setFilters}
                    filters={filters}
                    data={availableCouriers || []}
                    dataLoading={loading}
                    recall={() => setRecall(!recall)}
                />
            </Row>
            <Row justify="end">
                <ActionButtons filters={filters} recall={() => setRecall(!recall)} />
            </Row>
            <Row>
                <ResponsiveDataTable
                    loading={loading}
                    data={availableCouriers || []}
                    dataCount={0}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                />
            </Row>
        </div>
    );
};
